import { render, staticRenderFns } from "./BuscarExtranjero.vue?vue&type=template&id=46e0de60&"
import script from "./BuscarExtranjero.vue?vue&type=script&lang=js&"
export * from "./BuscarExtranjero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports